import { cn } from "@/lib/utils";

interface LoadingProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  text?: string;
}

export function Loading({ className, size = "md", text }: LoadingProps) {
  const sizeClasses = {
    sm: "h-6 w-6 text-sm",
    md: "h-8 w-8 text-base",
    lg: "h-12 w-12 text-xl"
  };

  const containerSizeClasses = {
    sm: "gap-2",
    md: "gap-3",
    lg: "gap-4"
  };

  return (
    <div
      data-testid="loading-spinner"
      className={cn(
        "flex flex-col items-center justify-center min-h-screen",
        containerSizeClasses[size],
        className
      )}
    >
      <div className="relative">
        {/* Outer spinning ring */}
        <div
          className={cn(
            "rounded-full border-2 border-[#d769b3]/20 border-t-[#d769b3] animate-spin",
            size === "sm"
              ? "h-12 w-12"
              : size === "md"
                ? "h-16 w-16"
                : "h-20 w-20"
          )}
        />

        {/* Logo container - positioned in center */}
        <div
          className={cn("absolute inset-0 flex items-center justify-center")}
        >
          <div
            className={cn(
              "rounded-md bg-[#d769b3] flex items-center justify-center text-[#471999] font-bold animate-pulse",
              sizeClasses[size]
            )}
          >
            <strong>W</strong>
          </div>
        </div>
      </div>
      {text && (
        <p className="text-[#471999] font-medium animate-pulse">{text}</p>
      )}
    </div>
  );
}
